import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    const clickedNode = document.querySelector(`a[href="${location.pathname}"]`)
    if (!clickedNode) {
      return
    }
    clickedNode.closest('ul').classList.add('is-active')
    clickedNode.closest('li').classList.add('is-current')
  }

  toggle(event) {
    let target = event.currentTarget.closest('li').querySelector('ul')
    if (!target) {
      return
    }
    target.classList.toggle('is-active')
  }
}
